import React from "react";
import { useOutletContext } from "react-router-dom";

const StudentCourseListing = () => {
    const [{ formikProps }]: any = useOutletContext()
    const { values } = formikProps;
    return (
        <div className=" p-1">
            <div className="flex justify-between items-center" >
                <span className="font-semibold text-xl">Courses</span>

            </div>
            {values?.courses?.map((el: any) => {
                return (
                    <div className="grid grid-cols-3 gap-4 font-semibold mt-4">
                        <div className="bg-slate-100 p-4 rounded-md">
                            <p>  {el?.courseName}</p>
                            <p> {el?.courseDescription}  </p>
                        </div>
                    </div>
                )

            })}
        </div>
    );
};

export default StudentCourseListing;
